export const ENERGY_PRODUCTION_HOST = 'energy.data2dollars.ai';
export const POSTHOG_KEY_PATTERN = /^phc_[A-Za-z0-9_-]{20,}$/;

export function isEnergyProductionHost(hostname) {
  return String(hostname || '').toLowerCase() === ENERGY_PRODUCTION_HOST;
}

export function hasValidPostHogConfig(key, host) {
  if (typeof key !== 'string' || !POSTHOG_KEY_PATTERN.test(key)) return false;
  try {
    const url = new URL(host);
    return url.protocol === 'https:' && Boolean(url.hostname);
  } catch {
    return false;
  }
}
